"use client"
import {
  slideshow_default
} from "./chunk-6FU6TVNY.js";

// src/modules/slideshow/slideshow.tsx
import { jsx } from "react/jsx-runtime";
var mSlideshow = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  return /* @__PURE__ */ jsx(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mSlideshow",
      id: _id,
      children: /* @__PURE__ */ jsx(slideshow_default, { id: `${_id}_slideshow`, ...content })
    }
  );
};
var slideshow_default2 = mSlideshow;

export {
  slideshow_default2 as slideshow_default
};
